import {
  AsyncPipe,
  NgClass,
  NgTemplateOutlet,
  TitleCasePipe,
  UpperCasePipe,
} from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  TemplateRef,
  output,
  inject,
  input,
  viewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { AppErrors, NotFoundError } from '@fitness-force/models';
import { ErrorMsgComponent, ErrorsComponent } from '@fitness-force/errors';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  COMPANY_INFO,
  STAGE_MASTER_STATE,
  TENANTS_INFO,
} from '@fitness-force/state';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { BehaviorSubject, map, Observable, of, Subject } from 'rxjs';

import { ChipModule } from 'primeng/chip';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import { InplaceModule } from 'primeng/inplace';
import { CONSTANTS_CRM, Outcome } from '@fitness-force/constants';
import {
  TaskOpportunityInfoComponent,
  LostDealComponent,
} from '@fitness-force/crm';

import { BillingComponent } from '@fitness-force/billing';

import { DatePickerModule } from 'primeng/datepicker';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { StyleClassModule } from 'primeng/styleclass';
import type {
  CreateCallOutcomeRequest,
  CreateFollowupTaskByDateRequest,
  CreateLogCallNotesRequest,
  CreateTourRequest,
  PlanSummary,
  PlanSummaryClient,
  PlanSummaryCRM,
  STAGE_MASTER_MODEL,
  TaskCategoryResponse,
  TENANTSINTERFACE,
  ValidationError,
} from '@fitness-force/models';
import { CallOutcome, TaskCategoryType } from '@fitness-force/enum';
import {
  ClientService,
  OpportunityService,
  TaskCategoryService,
  TimeconversionService,
  TaskCallOutcomeService,
  ToastMessageService,
} from '@fitness-force/api';

import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { AvatarModule } from 'primeng/avatar';

@Component({
  selector: 'app-call-outcome',
  templateUrl: './call-outcome.component.html',
  styleUrls: ['./call-outcome.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ToastMessageService],
  standalone: true,
  imports: [
    FormsModule,
    DialogModule,
    ButtonModule,
    SelectModule,
    ChipModule,
    InplaceModule,
    ReactiveFormsModule,
    TaskOpportunityInfoComponent,
    ToggleSwitchModule,
    DatePickerModule,
    StyleClassModule,
    ErrorMsgComponent,
    ErrorsComponent,
    BillingComponent,
    LostDealComponent,
    ShortNamePipe,
    AvatarModule,
    TranslateModule,
    AsyncPipe,
    NgClass,
    NgTemplateOutlet,
    TitleCasePipe,
    UpperCasePipe,
  ],
})
export class CallOutcomeComponent implements OnInit {
  store = inject(Store);
  translate = inject(TranslateService);
  private readonly clientService = inject(ClientService);
  private readonly fb = inject(UntypedFormBuilder);
  private readonly callOutcomeService = inject(TaskCallOutcomeService);
  private readonly timeService = inject(TimeconversionService);
  private readonly toastMessageService = inject(ToastMessageService);
  private readonly opportunityService = inject(OpportunityService);
  private readonly taskCategoryService = inject(TaskCategoryService);
  private readonly cd = inject(ChangeDetectorRef);

  getAccessTenantList$: Observable<any> | any;
  readonly truevalue: boolean = true;
  tenantId: number = 0;

  errMsg: Error | any;
  errorMessages = [] as any;
  showErrorPopup = new BehaviorSubject(false);
  errorDataModal = [] as ValidationError[];
  errorDataModalSubject = new BehaviorSubject([] as ValidationError[]);

  readonly showCallOutcome = input<boolean>(false, { alias: 'visible' });
  readonly modelData = input<any>(undefined, { alias: 'data' });

  localModelData: any = undefined;

  readonly hideOutCome = output<any>();
  readonly showClientProfile = output<any>();
  readonly modified = output<any>();

  readonly noanswer = viewChild<TemplateRef<any> | any>('noanswer');
  readonly contactmade = viewChild<TemplateRef<any> | any>('contactmade');
  readonly booktour = viewChild<TemplateRef<any> | any>('booktour');
  readonly notintrested = viewChild<TemplateRef<any> | any>('notintrested');
  readonly successfullfollowup = viewChild<TemplateRef<any> | any>(
    'successfullfollowup',
  );

  public companyInfoDetail$!: Observable<any>;
  companyDetails: any;

  stageMaster$: Observable<any> = new Subject();
  frmCallOutComeNoAnswer: UntypedFormGroup | any;
  frmCallOutcomeContactmade: UntypedFormGroup | any;
  frmCallOutcomeBookTour: UntypedFormGroup | any;
  frmCallOutNotInterested: UntypedFormGroup | any;
  frmCallOutcomeSuccessfullFollowup: UntypedFormGroup;

  convertibility: any = CONSTANTS_CRM.OPPORTUNITY_CONVERTITBILITY;

  selectedConvertibility!: any;
  outcome$ = new BehaviorSubject([] as Outcome[]);
  values: string[] | undefined;
  followUpDate: Date | undefined;
  contractEndDate: Date | undefined;
  mylookupservice: any;
  hideOnOutsideClick: any;
  selectedOutcome!: any;

  selectedOutcomeTemplate: any;
  selectTime!: string;
  markcompletedchecked: boolean = false;
  value: boolean = false;
  taskId: any;

  //#region billing sidebar
  planSummarydataObject$: BehaviorSubject<PlanSummary> = new BehaviorSubject(
    {} as PlanSummary,
  );
  showPaidFullSidebar: boolean = false;
  //#endregion billing sidebar

  showChooseReason: boolean = false;
  showLostDealDialog = false;
  lostDealItemInfo = '';
  showClientSidebar = false;
  activeClientId = 0;
  clientData: any;
  taskCategory: any;

  constructor() {
    this.showErrorPopup.next(false);
  }

  ngOnInit(): void {
    this.translateOutComeOption();
    this.componentInit();
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.store.dispatch({ type: 'ROUTER_GO' });
      }
    });

    const modelData = this.modelData();
    if (modelData?.latest_task) {
      this.GetCategoryType();
    }

    if (modelData?.client_info) {
      this.clientService.getClientById(modelData.client_info.id).subscribe({
        next: (res: any) => {
          this.clientData = res;
        }
      });
    }

    this.frmCallOutComeNoAnswer = this.fb.group({
      noanswer_expecteddate: new UntypedFormControl('', [Validators.required]),
      noanswer_expectedtime: new UntypedFormControl('', [Validators.required]),
      noanswer_notes: new UntypedFormControl(''),
      noanswer_markascomplete: new UntypedFormControl(
        this.markcompletedchecked,
        [Validators.required],
      ),
    });

    this.frmCallOutcomeContactmade = this.fb.group({
      contactmade_notes: new UntypedFormControl('', [Validators.required]),
      contactmade_expecteddate: new UntypedFormControl('', [
        Validators.required,
      ]),
      contactmade_expectedtime: new UntypedFormControl('', [
        Validators.required,
      ]),
    });

    this.frmCallOutNotInterested = this.fb.group({
      notintrested_markcompleted: new UntypedFormControl({
        value: this.truevalue,
        disabled: true,
      }),
      notintrested_notes: new UntypedFormControl('', [Validators.required]),
    });

    this.frmCallOutcomeSuccessfullFollowup = this.fb.group({
      successfulfollowup_markcompleted: new UntypedFormControl({
        value: this.truevalue,
        disabled: true,
      }),
      successfulfollowup_notes: new UntypedFormControl('', [
        Validators.required,
      ]),
    });

    this.frmCallOutcomeBookTour = this.fb.group({
      booktour_expecteddate: new UntypedFormControl('', [Validators.required]),
      booktour_expectedtime: new UntypedFormControl('', [Validators.required]),
      booktour_notes: new UntypedFormControl('', [Validators.required]),
    });
    this.stageMaster$ = this.store.select(STAGE_MASTER_STATE);
  }

  componentInit() {
    this.companyInfoDetail$ = this.store.select(COMPANY_INFO);
    this.companyInfoDetail$.subscribe((responseData) => {
      this.companyDetails = responseData;
      this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
      this.translate.use(responseData?.selectedLang?.LANG_CODE);
    });

    const modelData = this.modelData();
    if (modelData.client_info != undefined)
      this.activeClientId = modelData.client_info.id;
  }

  translateOutComeOption(): void {
    //this.outcome = CONSTANTS_CRM.CALL_OUTCOME.filter(o => o.shortname != 'followup');
    this.outcome$.next(CONSTANTS_CRM.CALL_OUTCOME);
    this.translate
      .get([
        'OUTCOME.CALLOUTCOME.NO_ANSWER_LEFT_MESSAGE',
        'OUTCOME.CALLOUTCOME.CONTACT_MADE',
        'OUTCOME.CALLOUTCOME.NOT_INTERESTED',
        'OUTCOME.CALLOUTCOME.BOOK_TOUR',
        'OUTCOME.CALLOUTCOME.SIGN_UP',
        'OUTCOME.CALLOUTCOME.FOLLOW_UP',
      ])
      .subscribe((translation) => {
        const outcomes = this.outcome$.getValue();
        outcomes.forEach((obj: any) => {
          switch (String(obj.shortname).toLowerCase()) {
            case 'noanswer':
              obj.name =
                translation['OUTCOME.CALLOUTCOME.NO_ANSWER_LEFT_MESSAGE'];
              break;
            case 'contactmade':
              obj.name = translation['OUTCOME.CALLOUTCOME.CONTACT_MADE'];
              break;
            case 'notintrested':
              obj.name = translation['OUTCOME.CALLOUTCOME.NOT_INTERESTED'];
              break;
            case 'booktour':
              obj.name = translation['OUTCOME.CALLOUTCOME.BOOK_TOUR'];
              break;
            case 'signup':
              obj.name = translation['OUTCOME.CALLOUTCOME.SIGN_UP'];
              break;
            case 'followup':
              obj.name = translation['OUTCOME.CALLOUTCOME.FOLLOW_UP'];
              break;
            default:
              break;
          }
        });
        this.outcome$.next(outcomes);
      });
  }

  GetCategoryType() {
    // Use task's tenant_id instead of current user's tenant
    const taskTenantId = this.modelData()?.tenant_id || this.tenantId;
    this.taskCategoryService
      .getTaskCategoryById(
        taskTenantId,
        this.modelData().latest_task.category_id,
      )
      .subscribe({
        next: (data: TaskCategoryResponse) => {
          const outcomes = this.outcome$.getValue();
          if (
            data.type == TaskCategoryType.Operational ||
            data.type.toString() ==
              TaskCategoryType[TaskCategoryType.Operational]
          ) {
            this.outcome$.next(
              outcomes.filter(
                (o) =>
                  o.shortname != 'notintrested' &&
                  o.shortname != 'booktour' &&
                  o.shortname != 'signup',
              ),
            );
          } else {
            this.outcome$.next(
              outcomes.filter((o) => o.shortname != 'followup'),
            );
          }
        },
        error: (error: AppErrors) => {
          this.errorDataModal = [] as ValidationError[];

          // Handle different error response formats
          let errorMessage = 'An error occurred';

          if (error instanceof NotFoundError) {
            errorMessage =
              error.originalError?.error?.errorMessage ||
              error.originalError?.message ||
              'Resource not found';
          } else if (error.originalError?.error?.errorMessage) {
            // Standard API error format
            errorMessage = error.originalError.error.errorMessage;
          } else if (error.originalError?.error?.title) {
            // RFC error format (like 404 Not Found)
            errorMessage = error.originalError.error.title;
          } else if (
            error.originalError?.error &&
            typeof error.originalError.error === 'string'
          ) {
            // Simple string error
            errorMessage = error.originalError.error;
          } else if (
            error.originalError?.error &&
            Array.isArray(error.originalError.error)
          ) {
            // Array of errors
            error.originalError.error.forEach((e: any) => {
              this.errorMessages.push(e.errorMessage || e.message || e);
            });
            this.errorDataModal = this.errorMessages;
            this.errorDataModalSubject.next(this.errorDataModal);
            this.showErrorPopup?.next(true);
            return;
          }

          this.errorMessages.push(errorMessage);
          this.errorDataModal = this.errorMessages;
          this.errorDataModalSubject.next(this.errorDataModal);
          this.showErrorPopup?.next(true);
        },
      });
  }

  //#region  "generic"
  setHidePopup(modified: boolean = false) {
    this.clearAllFields();
    this.hideOutCome.emit({ showPopup: false, modified: false });
    this.hideOutCome.emit({ showPopup: this.showCallOutcome(), modified });
  }

  HideErrorPopup(event: any) {
    this.showErrorPopup?.next(false);
    this.errorMessages = [];
  }

  get ShowErrorPopup(): Observable<boolean> {
    return this.showErrorPopup?.asObservable() || of(false);
  }

  get getErrorData(): Observable<ValidationError[]> {
    return of(this.errorDataModalSubject.getValue());
  }

  SelectOutcome(item: any) {
    this.selectedOutcome = item;

    if (item.shortname == 'noanswer') {
      this.selectedOutcomeTemplate = this.noanswer();
    }
    if (item.shortname == 'contactmade')
      this.selectedOutcomeTemplate = this.contactmade();
    if (item.shortname == 'notintrested')
      this.selectedOutcomeTemplate = this.notintrested();
    if (item.shortname == 'booktour')
      this.selectedOutcomeTemplate = this.booktour();
    if (item.shortname == 'signup') {
      // this.selectedOutcomeTemplate = this.signupform;
      const draggedProduct = this.modelData();
      const planSummary: PlanSummary = {
        id: 0,
        from_subscription_id: 0,
        client: {
          client_id: draggedProduct.client_info.id,
          client_name: draggedProduct.client_info.full_name,
          client_status: draggedProduct.client_info.status,
        } as PlanSummaryClient,
        couponcode: null,
        tenant_id: this.modelData()?.tenant_id || this.tenantId,
        company_id: draggedProduct.company_id,
        startdate: new Date(),
        plan_selectable: true,
        CRM: {
          opp_id: draggedProduct.id,
          task_id: draggedProduct.latest_task?.id || 0,
          board_id: draggedProduct.board_type,
        } as PlanSummaryCRM,
        Scheduling: null,
      } as PlanSummary;

        this.planSummarydataObject$.next(planSummary);
        this.showPaidFullSidebar = true;
    }
    if (item.shortname == 'followup')
      this.selectedOutcomeTemplate = this.successfullfollowup();
  }

  closeBillingSidebar() {
    this.showPaidFullSidebar = false;
    this.planSummarydataObject$.next({} as PlanSummary);
  }

  hideBillingSummary(event: any) {
    this.showPaidFullSidebar = false;
    this.planSummarydataObject$.next({} as PlanSummary);
    if (event.uuid && String(event.uuid).trim() != '') {
      this.setHidePopup();
    }
  }

  SelectOutcomeMob(item: any) {
    this.SelectOutcome(item.value);
  }

  get getoutcome(): any {
    return this.selectedOutcomeTemplate;
  }

  clearAllFields() {
    //NO ANSWER CLEAR DATA
    this.getNoAnswer_MarkasComplete.value = false;
    this.getNoAnswer_ExpectedDate.value = '';
    this.getNoAnswer_ExpectedTime.value = '';
    this.getNoAnswer_Notes.value = '';

    this.getBookTour_ExpectedDate.value = '';
    this.getBookTour_ExpectedTime.value = '';
    this.getBookTour_Notes.value = '';

    this.getContactMade_ExpectedDate.value = '';
    this.getContactMade_ExpectedTime.value = '';
    this.getContactMade_Notes.value = '';

    this.getNotInterested_Notes.value = '';

    this.getSuccessfullFollowup_Notes?.setValue('');
  }

  //#endregion

  //#region "No Answer / Left a message"

  CreateCallOutcomeNoAnswer(formdata: UntypedFormGroup) {
    this.frmCallOutComeNoAnswer.markAllAsTouched();

    if (!this.frmCallOutComeNoAnswer.valid) {
      return;
    }

    this.errorDataModalSubject = new BehaviorSubject([] as ValidationError[]);

    const createCallOutcomeRequest: CreateCallOutcomeRequest =
      {} as CreateCallOutcomeRequest;
    const logCall = {} as CreateLogCallNotesRequest;
    const reschedule_task = {} as CreateFollowupTaskByDateRequest;

    logCall.transaction_notes = this.getNoAnswer_Notes.value;
    logCall.transaction_log_date = new Date().toISOString();

    createCallOutcomeRequest.mark_as_complete =
      this.getNoAnswer_MarkasComplete.value;
    reschedule_task.scheduled_datetime =
      this.timeService.GetUTCDateTimeByDateAndTime(
        this.getNoAnswer_ExpectedDate.value,
        this.getNoAnswer_ExpectedTime.value,
      );

    createCallOutcomeRequest.outcome = CallOutcome.NoAnswer_LeftMessage;
    createCallOutcomeRequest.log_call = logCall;
    if (!createCallOutcomeRequest.mark_as_complete)
      createCallOutcomeRequest.reschedule_task = reschedule_task;

    this.callOutcomeService
      .createTaskCallOutcome(
        createCallOutcomeRequest,
        this.modelData()?.tenant_id || this.tenantId,
        this.modelData().latest_task.id,
      )
      .subscribe({
        next: async () => {
          this.translate
            .get('common.message.record_updated')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });

          await this.timeout(1000);
          this.selectedOutcome = null;
          this.selectedOutcomeTemplate = null;
          this.clearAllFields();
          this.setHidePopup(true);
        },
        error: (error: AppErrors) => {
          this.handleError(error);
        },
      });
  }

  get getNoAnswer_MarkasComplete() {
    return this.frmCallOutComeNoAnswer.get('noanswer_markascomplete');
  }

  get getNoAnswer_ExpectedDate() {
    return this.frmCallOutComeNoAnswer.get('noanswer_expecteddate');
  }

  get getNoAnswer_ExpectedTime() {
    return this.frmCallOutComeNoAnswer.get('noanswer_expectedtime');
  }

  get getNoAnswer_Notes() {
    return this.frmCallOutComeNoAnswer.get('noanswer_notes');
  }

  setNoAnswer_MarkCompleteValidator() {
    if (
      this.frmCallOutComeNoAnswer != undefined &&
      this.frmCallOutComeNoAnswer != null
    ) {
      this.frmCallOutComeNoAnswer
        .get('noanswer_markascomplete')
        .valueChanges.subscribe((value: boolean) => {
          if (value === true) {
            this.getNoAnswer_ExpectedDate.setValidators(null);
            this.getNoAnswer_ExpectedTime.setValidators(null);
          } else {
            this.getNoAnswer_ExpectedDate.setValidators([Validators.required]);
            this.getNoAnswer_ExpectedTime.setValidators([Validators.required]);
          }
        });
    }
  }

  toggleNoAnswer(isChecked: boolean) {
    this.markcompletedchecked = isChecked;
    if (isChecked) {
      this.noAnswerDisableControls();
    } else {
      this.noAnswerEnableControls();
    }
  }

  noAnswerDisableControls() {
    //this.Name.disable()
    this.getNoAnswer_ExpectedDate.setValue(null);
    this.getNoAnswer_ExpectedTime.setValue(null);

    this.getNoAnswer_ExpectedDate.disable();
    this.getNoAnswer_ExpectedTime.disable();

    this.getNoAnswer_ExpectedDate.setValidators([Validators.required]);
    this.getNoAnswer_ExpectedTime.setValidators([Validators.required]);
  }

  noAnswerEnableControls() {
    this.getNoAnswer_ExpectedDate.enable();
    this.getNoAnswer_ExpectedTime.enable();

    this.getNoAnswer_ExpectedDate.setValidators(null);
    this.getNoAnswer_ExpectedTime.setValidators(null);
  }

  //#endregion

  //#region "Call Outcome"
  CreateCallOutcomeContactMade(formdata: UntypedFormGroup) {
    this.frmCallOutcomeContactmade.markAllAsTouched();
    if (!this.frmCallOutcomeContactmade.valid) {
      return;
    }

    const createCallOutcomeRequest: CreateCallOutcomeRequest = {} as CreateCallOutcomeRequest;
    const logCall = {} as CreateLogCallNotesRequest;
    const reschedule_task = {} as CreateFollowupTaskByDateRequest;

    logCall.transaction_notes = this.getContactMade_Notes.value;
    logCall.transaction_log_date = new Date().toISOString();

    reschedule_task.scheduled_datetime =
      this.timeService.GetUTCDateTimeByDateAndTime(
        this.getContactMade_ExpectedDate.value,
        this.getContactMade_ExpectedTime.value,
      );

    //createCallOutcomeRequest.mark_as_complete = this.getNoAnswer_MarkasComplete.value;
    createCallOutcomeRequest.outcome = CallOutcome.ContactMade;
    createCallOutcomeRequest.log_call = logCall;
    createCallOutcomeRequest.reschedule_task = reschedule_task;

    this.callOutcomeService
      .createTaskCallOutcome(
        createCallOutcomeRequest,
        this.tenantId,
        this.modelData().latest_task.id,
      )
      .subscribe({
        next: async () => {
          this.translate
            .get('common.message.record_updated')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });

          await this.timeout(1000);

          this.clearAllFields();
          this.setHidePopup(true);
          this.selectedOutcome = null;
          this.selectedOutcomeTemplate = null;
        },
        error: (error: AppErrors) => {
          this.handleError(error);
        },
      });
    this.errorDataModalSubject.next(this.errorDataModal);
  }

  get getContactMade_Notes() {
    return this.frmCallOutcomeContactmade.get('contactmade_notes');
  }

  get getContactMade_ExpectedDate() {
    return this.frmCallOutcomeContactmade.get('contactmade_expecteddate');
  }

  get getContactMade_ExpectedTime() {
    return this.frmCallOutcomeContactmade.get('contactmade_expectedtime');
  }

  //#endregion

  //#region "NotInterested"

  CreateNotInteresredNotInterested() {
    this.frmCallOutNotInterested.markAllAsTouched();
    if (!this.frmCallOutNotInterested.valid) {
      return;
    }

    const createCallOutcomeRequest: CreateCallOutcomeRequest = {} as CreateCallOutcomeRequest;
    const logCall = {} as CreateLogCallNotesRequest;

    logCall.transaction_notes = this.getNotInterested_Notes.value;
    logCall.transaction_log_date = new Date().toISOString();

    createCallOutcomeRequest.mark_as_complete =
      this.getNotInterested_MarkCompleted.value;
    createCallOutcomeRequest.outcome = CallOutcome.NotIntrested;
    createCallOutcomeRequest.log_call = logCall;

    this.callOutcomeService
      .createTaskCallOutcome(
        createCallOutcomeRequest,
        this.tenantId,
        this.modelData().latest_task.id,
      )
      .subscribe({
        next: () => {
          this.translate
            .get('common.message.record_updated')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          // open lost deal only if it is opportunity
          const modelData = this.modelData();
          if (modelData.stage_master_id) {
            this.OpenLostDeal(modelData);
          }
          this.clearAllFields();
          //this.setHidePopup(true);
          this.selectedOutcome = null;
          this.selectedOutcomeTemplate = null;
        },
        error: (error: AppErrors) => {
          this.handleError(error);
        },
      });
    this.errorDataModalSubject.next(this.errorDataModal);
  }

  get getNotInterested_Notes() {
    return this.frmCallOutNotInterested.get('notintrested_notes');
  }

  get getNotInterested_MarkCompleted() {
    return this.frmCallOutNotInterested.get('notintrested_markcompleted');
  }

  get getSuccessfullFollowup_Notes() {
    return this.frmCallOutcomeSuccessfullFollowup.get(
      'successfulfollowup_notes',
    );
  }

  get getSuccessfullFollowup_MarkCompleted() {
    return this.frmCallOutcomeSuccessfullFollowup.get(
      'successfulfollowup_markcompleted',
    );
  }

  //#endregion

  //#region  "BookTour"

  CreateCallOutcomeBookTour(formdata: UntypedFormGroup) {
    this.frmCallOutcomeBookTour.markAllAsTouched();

    if (!this.frmCallOutcomeBookTour.valid) {
      return;
    }

    const createCallOutcomeRequest: CreateCallOutcomeRequest = {} as CreateCallOutcomeRequest;
    const logCall = {} as CreateLogCallNotesRequest;

    logCall.transaction_notes = this.getBookTour_Notes.value;
    logCall.transaction_log_date = new Date().toISOString();

    const book_tour = {} as CreateTourRequest;
    book_tour.scheduled_datetime = this.timeService.GetUTCDateTimeByDateAndTime(
      this.getBookTour_ExpectedDate.value,
      this.getBookTour_ExpectedTime.value,
    );
    book_tour.assigned_to_staff_id = this.modelData().assigned_to_staff_id;

    //createCallOutcomeRequest.mark_as_complete = this.getNoAnswer_MarkasComplete.value;
    createCallOutcomeRequest.outcome = CallOutcome.BookTour;
    createCallOutcomeRequest.log_call = logCall;

    createCallOutcomeRequest.book_tour = book_tour;
    createCallOutcomeRequest.mark_as_complete = true;
    this.callOutcomeService
      .createTaskCallOutcome(
        createCallOutcomeRequest,
        this.tenantId,
        this.modelData().latest_task.id,
      )
      .subscribe({
        next: async () => {
          this.translate
            .get('common.message.record_updated')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });

          await this.timeout(1000);
          this.lostDealItemInfo = this.modelData();
          this.clearAllFields();
          this.setHidePopup(true);
          this.selectedOutcome = null;
          this.selectedOutcomeTemplate = null;
        },
        error: (error: AppErrors) => {
          this.handleError(error);
        },
      });
    this.errorDataModalSubject.next(this.errorDataModal);
  }

  get getBookTour_ExpectedDate() {
    return this.frmCallOutcomeBookTour.get('booktour_expecteddate');
  }

  get getBookTour_ExpectedTime() {
    return this.frmCallOutcomeBookTour.get('booktour_expectedtime');
  }

  get getBookTour_Notes() {
    return this.frmCallOutcomeBookTour.get('booktour_notes');
  }

  CreateSuccessFullFollowUp() {
    this.frmCallOutcomeSuccessfullFollowup.markAllAsTouched();
    if (!this.frmCallOutcomeSuccessfullFollowup.valid) {
      return;
    }

    this.errorDataModalSubject = new BehaviorSubject([] as ValidationError[]);

    const createCallOutcomeRequest: CreateCallOutcomeRequest = {} as CreateCallOutcomeRequest;
    const logCall = {} as CreateLogCallNotesRequest;
    const reschedule_task = {} as CreateFollowupTaskByDateRequest;

    logCall.transaction_notes =
      this.frmCallOutcomeSuccessfullFollowup.controls.successfulfollowup_notes.value;
    logCall.transaction_log_date = new Date().toISOString();

    createCallOutcomeRequest.mark_as_complete = this.frmCallOutcomeSuccessfullFollowup.controls.successfulfollowup_markcompleted.value;
    reschedule_task.scheduled_datetime = '';
    createCallOutcomeRequest.outcome = CallOutcome.SuccessfulFollowUp;
    createCallOutcomeRequest.log_call = logCall;
    if (!createCallOutcomeRequest.mark_as_complete)
      createCallOutcomeRequest.reschedule_task = reschedule_task;

    this.callOutcomeService
      .createTaskCallOutcome(
        createCallOutcomeRequest,
        this.modelData()?.tenant_id || this.tenantId,
        this.modelData().latest_task.id,
      )
      .subscribe({
        next: async () => {
          this.translate
            .get('common.message.record_updated')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });

          await this.timeout(1000);
          this.selectedOutcome = null;
          this.selectedOutcomeTemplate = null;
          this.clearAllFields();
          this.setHidePopup(true);
        },
        error: (error: AppErrors) => {
          this.handleError(error);
        },
      });
  }

  GetErrorData(event: any) {
    this.errorMessages = event.errors;
    this.showErrorPopup?.next(event.showErrors);
  }

  GetUpdatedData(event: any) {
    this.localModelData = event;
    this.modified.emit(true);
  }

  closeDailog() {
    this.showChooseReason = false;
    this.showLostDealDialog = false;
    this.clearAllFields();
    this.setHidePopup(true);
  }

  OpenLostDeal(modatData: any) {
    this.showChooseReason = true;
    this.lostDealItemInfo = modatData;
    this.cd.detectChanges();
  }

  clientStatus(client: any): string {
    if (client?.status)
      return this.clientService.getClientStatusHtml(client.status.toString());
    else return '';
  }

  getStageStatus(stageMasterid: number): Observable<string | undefined> {
    return this.store
      .select(STAGE_MASTER_STATE)
      .pipe(
        map(
          (value: STAGE_MASTER_MODEL[]) =>
            value.find((obj) => obj.id == stageMasterid)?.name_primary_language,
        ),
      );
  }

  goToClientProfile(clientId: number) {
    this.activeClientId = this.modelData().client_info.id;
    this.showClientProfile.emit({ clientId: this.activeClientId });
  }

  GoToClientDetails(event: any) {
    this.showPaidFullSidebar = false;
    this.activeClientId = this.modelData().client_info.id;
    this.setHidePopup(true);
    this.showClientProfile.emit({ clientId: this.activeClientId });
  }

  timeout(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  handleError(error: any) {
    this.errorDataModal = [] as ValidationError[];
    if (error instanceof NotFoundError) {
      this.errMsg = error.originalError.message;
      this.errorMessages.push(error.originalError.error.errorMessage);
      this.showErrorPopup?.next(true);
    } else {
      if (error.originalError.status == 500) {
        this.errorMessages.push(error.originalError.error.errorMessage);
        this.errorDataModal = this.errorMessages;
      } else {
        error.originalError.error.forEach((e: any) => {
          this.errorMessages.push(e.errorMessage);
        });
        this.errorDataModal = this.errorMessages;
      }
      this.errorDataModalSubject.next(this.errorDataModal);
      this.showErrorPopup?.next(true);
    }
  }

  closeErrorDialog() {
    this.showErrorPopup?.next(false);
    this.errorMessages = [];
    this.errorDataModal = [];
    this.errorDataModalSubject.next([]);
  }
}
